import { render, staticRenderFns } from "./CedentesList.vue?vue&type=template&id=e5f10a96"
import script from "./CedentesList.vue?vue&type=script&lang=js"
export * from "./CedentesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports